var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.schema.options ? 'b-form-checkbox-group' : 'b-form-checkbox',_vm._b({tag:"component",model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'component',{ ..._vm.schema, ..._vm.schema.attributes },false),[_c('span',{staticClass:"font-size-12 text-dark",domProps:{"innerHTML":_vm._s(_vm.schema.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }